import { Component, OnInit } from '@angular/core';
import { CouponService } from '../../services/coupon.service';
import { FormBuilder, FormGroup, } from '@angular/forms'
import { menurolesService } from '../../services/menuroles.service';
@Component({
  selector: 'app-user-coupons',
  templateUrl: './user-coupons.component.html',
  styleUrls: ['./user-coupons.component.scss']
})
export class UserCouponsComponent implements OnInit {
  public isPageEditable: boolean = false;
  public isdisplayByPatient: boolean = true;
  public isdisplayByCoupons: boolean = false;
  public patientList: any[];
  public couponsSelectList: any[];
  public coupons: any[]
  public selectedCouponid: number = -1;
  public isSlide: boolean = false;
  couponForm: FormGroup;
  constructor(private fb: FormBuilder, private _couponService: CouponService, private _menurolesService: menurolesService) {
    this.selectedCouponid = -1;

    this.couponForm = fb.group({
      selectedCouponid: ['',],
      couponsSelectList: [],
    })

  }

  ngOnInit() {
    this.getAllCoupons();
    this.isPageEditable = this._menurolesService.getpageAcessbility()
  }

  getPatientsList() {
    this.patientList = [];
    this.isdisplayByPatient = true;
    this.isdisplayByCoupons = false;
    this._couponService.getPatientsCouponsList(this.selectedCouponid)
      .subscribe(
        (employeeData) => {
          if (employeeData == null) {
            //this.statusMessage = "Patients does not exist..";
          }
          else {
            this.patientList = employeeData.response.patientList
          }
        },
        (error) => {
          //this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        }
      );
  }

  getAllCoupons() {
    this._couponService.getcoupans()
      .subscribe(
        (couponData) => {
          if (couponData.response == null) {
            this.couponsSelectList = [];
          }
          else {
            this.couponsSelectList = couponData.response.couponList.filter(t => (t.isusedforall == false) && (t.isPublished == true));
            this.selectedCouponid = this.couponsSelectList[0].couponId
            this.getPatientsList();
          }
          console.log(this.couponsSelectList);
        },
        (error) => {
          // this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        }

      );
  }

  assignCoupons() {
    this._couponService.getcoupans()
      .subscribe(
        (couponData) => {
          if (couponData.response == null) {
            this.couponsSelectList = null
          }
          else {
            this.couponsSelectList = couponData.response.couponList

          }
          console.log(this.couponsSelectList);
        },
        (error) => {
          // this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        }

      );
  }

  selectOption(id: number) {
    this.selectedCouponid = id;
    this.getPatientsListbycoupons(this.selectedCouponid)
  }

  getPatientsListbycoupons(selectedCouponid) {
    this.isdisplayByPatient = true;
    this.isdisplayByCoupons = false;
    this._couponService.getPatientsCouponsList(selectedCouponid)
      .subscribe(
        (employeeData) => {
          if (employeeData == null) {
            //this.statusMessage = "Patients does not exist..";
          }
          else {
            this.patientList = employeeData.response.patientList
          }
        },
        (error) => {
          //this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        }
      );
  }

  assignCoupon(userdata) {
    let confimationMessage = userdata.IsSlotAssign == true ? "Are you sure want to Unassigned " + userdata.patientName : "Are you sure want to Assigned " + userdata.patientName;
    if (confirm(confimationMessage)) {
      if (this.selectedCouponid) {
        this._couponService.assignCoupon(userdata, this.selectedCouponid).subscribe(
          data => {
            if (data.returnCode == 0) {
              alert("Coupons records save Sucessfully")
              this.getPatientsList();
            }
            else {
              alert(data.returnMsg)
            }
          },
          error => {
            // this.alertService.error(error);
            // this.loading = false;         
            alert(error)
            console.log(error)
          });
      }
      else {
        alert("Please select a coupon")
        return;
      }
    }
    else {
      this.getAllCoupons();
    }

  }

  onSearchChange(searchValue: string) {
    this._couponService.getPatientsCouponsList(this.selectedCouponid)
      .subscribe(
        (employeeData) => {
          if (employeeData == null) {
            //this.statusMessage = "Patients does not exist..";
          }
          else {
            this.patientList = employeeData.response.patientList.filter(t => (t.patientName != null && t.patientName.toLowerCase().indexOf(searchValue) > -1) || (t.email != null && t.email.toLowerCase().indexOf(searchValue) > -1) || (t.mobile != null && t.mobile.indexOf(searchValue) > -1));
          }
        },
        (error) => {
          //this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        }
      );
  }

  sideBarToggle() {
    if (this.isSlide) {
      this.isSlide = false;
    }
    else {
      this.isSlide = true;
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/admin/user-coupons/user-coupons.component.ts